/* ============================================================================== */
/*                    Database file with routing information                      */
/* ============================================================================== */

/*
  -- The IDs of the items are sequential just for uniqueness purposes, in fact the string represents a name, NOT an ordered succession, as order may vary depending on the customer's requirements.
  -- The only naming convetion applied is q - question, a - answers.
  -- Some questions actually contain an answer that directly leads to another question, thus they are combined into one question element
  -- There are many duplicate questions, as different path could lead to the same question. There could be other ways to optimize this but for the purpose is this small applciation, this is not necessary.
  -- TO DO: There are currently three decision making tools. The logic must be the same, the problem is the CSS framework they run on.
            Depending on the destination environment, there might be different version of Bootstrap... how to address this problem?
  -------
*/

var questions = [
	// q-1
	{
		id: "q-1",
		question: `First, let's start by identifying what type of outputs your research will generate.`,
		top_text: `
         <p>Some projects generate <strong>data</strong> such as DNA sequences, medical imaging, or statistical analyses of other data. Others may generate novel <strong>model organisms</strong> or <strong>research tools</strong> such as algorithms, mice, or laboratory equipment.</p>
         <p>Note that activities such as training, infrastructure development, and other non-research activities may not directly generate research outputs at all.</p>
         <p>Your research may produce more than one of these types of outputs. Please go through the decision tool for one output at a time and then select the "start over" button to explore additional outputs.</p>
      `,
		bottom_text: `
         <strong>Need help answering this question? See these resources:</strong><br>
         <a href="/policy-and-compliance/policy-topics/sharing-policies/other/model-organism#definitions-of-model-organisms-and-related-resources">Definitions of Model Organisms and Related Resources</a><br>
         <a href="/policy-and-compliance/policy-topics/sharing-policies/other/research-tools#definition-of-research-tools">Definition of Research Tools</a>
      `,
		type: "radio",
		options: [
			{
				text: "Data",
				target: "q-2",
			},
			{
				text: "Model Organisms",
				target: "q-13",
			},
			{
				text: "Research Tools",
				target: "q-17",
			},
			{
				text: "None of the above",
				target: "a-22",
			},
		],
	},
	// q-2
	{
		id: "q-2",
		question: "Does your research generate large-scale genomic data or use such data for subsequent research?",
		top_text: ``,
		bottom_text: `
         <strong>Need help answering this question? See these resources:</strong><br>
         <a href="/policy-and-compliance/policy-topics/sharing-policies/gds/overview#applicability">GDS Applicability</a><br>
         <a href="/policy-and-compliance/policy-topics/sharing-policies/gds/expectations-by-ics">GDS Data Sharing Expectations by NIH Institute & Center</a>
      `,
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "q-5",
			},
			{
				text: "No",
				target: "q-3",
			},
		],
	},
	// q-3
	{
		id: "q-3",
		pre_text: "",
		question:
			"Now we need to ask you about timing, as the NIH Data Management and Sharing Policy came into effect on January 25, 2023. Did you or do you plan to:",
		top_text: `
            -- Submit your grant application for a receipt date <strong>on or after January 25, 2023</strong>, OR<br>
            -- Submit your contract proposal <strong>on or after January 25, 2023</strong>, OR<br>
            -- Conduct your intramural research project <strong>on or after January 25, 2023</strong>, OR<br>
            -- Execute a funding agreement starting <strong>on or after January 25, 2023</strong>(unless otherwise stipulated)
      `,
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "a-7",
			},
			{
				text: "No",
				target: "q-4",
			},
		],
	},
	// q-4
	{
		id: "q-4",
		question:
			"Are you or were you seeking $500,000 or more in direct costs through an extramural grant, cooperative agreement, or contract?",
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "a-6",
			},
			{
				text: "No",
				target: "a-12",
			},
		],
	},
	// q-5
	{
		id: "q-5",
		pre_text: ``,
		question:
			"Now we need to ask you about timing, as the NIH Data Management and Sharing Policy came into effect on January 25, 2023. Did you or do you plan to:",
		top_text: `
         -- Submit your grant application for a receipt date <strong>on or after January 25, 2023</strong>, OR<br>
         -- Submit your contract proposal <strong>on or after January 25, 2023</strong>, OR<br>
         -- Conduct your intramural research project <strong>on or after January 25, 2023</strong>, OR<br>
         -- Execute a funding agreement starting <strong>on or after January 25, 2023</strong> (unless otherwise stipulated)
      `,
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "a-11",
			},
			{
				text: "No",
				target: "q-8",
			},
		],
	},
	// q-8
	{
		id: "q-8",
		question:
			"Are you or were you seeking $500,000 or more in direct costs through an extramural grant, cooperative agreement, or contract?",
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "a-10",
			},
			{
				text: "No",
				target: "a-9",
			},
		],
	},
	// q-13
	{
		id: "q-13",
		question:
			"Will your project generate, or has your project generated, a <strong>novel</strong>, non-prokaryote model organism or related resource?",
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "q-15",
			},
			{
				text: "No",
				target: "a-14",
			},
		],
		bottom_text: `
      <strong>For help answering this question, see:</strong><br>
      <a href="/policy-and-compliance/policy-topics/sharing-policies/other/model-organism#definitions-of-model-organisms-and-related-resources">Definitions of Model Organisms and Related Resources</a><br>
   `,
	},
	// q-15
	{
		id: "q-15",
		question: "Is the funding source for the project a grant, contract, or cooperative agreement?",
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "a-16",
			},
			{
				text: "No",
				target: "a-14",
			},
		],
	},
	// q-17
	{
		id: "q-17",
		pre_text: `In the NIH Guide Notice for sharing research tools, one criteria for determining whether a resource is a “research tool” is whether the “primary usefulness of the resource is as a tool for discovery rather than an FDA-approved product or integral component of such a product.”`,
		question:
			"Are you developing a resource as a tool for discovery, rather than an FDA-approved product or integral component of such a product?",
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "q-18",
			},
			{
				text: "No",
				target: "a-21",
			},
		],
	},
	// q-18
	{
		id: "q-18",
		question: `Is the product a broad enabling invention that will be useful to many scientists (or multiple companies in developing multiple products), as opposed to a project or product-specific resource?`,
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "q-19",
			},
			{
				text: "No",
				target: "a-21",
			},
		],
	},
	// q-19
	{
		id: "q-19",
		question: `Is the resource complete and readily useable or distributable? `,
		type: "radio",
		options: [
			{
				text: "Yes",
				target: "a-20",
			},
			{
				text: "No",
				target: "a-21",
			},
		],
	},
];

var answers = [
	// a-6
	{
		id: "a-6",
		answer: `<i class="fas fa-check-circle me-2 text-success"></i>Based on your answers, the <strong>2003 Data Sharing Policy</strong> applies to your research.`,
		note: `
         <p>The 2003 Data Sharing Policy applies to <strong>final research data</strong>, defined as recorded factual material commonly accepted in the scientific community as necessary to validate research findings. Final research data do not include laboratory notebooks, partial datasets, preliminary analyses, drafts of scientific papers, plans for future research, peer review reports, communications with colleagues, or physical objects, such as gels or laboratory specimens.<p>
         <p>Other NIH sharing policies may also apply. Select the “Start Over” button to learn about policies for other research outputs (i.e., model organisms, research tools).</p>
         <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>
         `,
		links: `Resources:<br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/dms/policy-overview#2003-nih-data-sharing-policy'>2003 Data Sharing Policy</a>`,
	},
	// a-7
	{
		id: "a-7",
		answer: `<i class="fas fa-check-circle me-2 text-success"></i>Based on your answers, the <strong>2023 Data Management & Sharing (DMS) Policy</strong> applies to your research`,
		note: `
         <p>The DMS Policy, effective on January 25, 2023, applies to all research, funded or conducted in whole or in part by NIH, that results in the generation of <strong>scientific data. Scientific Data</strong> is defined as data commonly accepted in the scientific community as of sufficient quality to validate and replicate research findings, regardless of whether the data are used to support scholarly publications.<p>
         <p>Other NIH sharing policies may also apply. Select the “Start Over” button to learn about policies for other research outputs (i.e., model organisms, research tools).</p>
         <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>
         `,
		links: `Resources:<br>
         <a href='/data-management-and-sharing-policy/about-data-management-sharing-policy/data-management-and-sharing-policy-overview'>2023 Data Management & Sharing (DMS) Policy Overview</a>`,
	},
	// a-9
	{
		id: "a-9",
		answer: `<i class="fas fa-check-circle me-2 text-success"></i> Based on your answers, the <strong>Genomic Data Sharing Policy</strong> applies to your research.`,
		note: `
         <p>The Genomic Data Sharing Policy applies to all NIH-funded research (e.g., grants, contracts, and intramural research) that generates <strong>large-scale human or non-human genomic data</strong>, regardless of the funding level, as well as the use of these data for subsequent research.</p>
         <p>Other NIH sharing policies may still apply. Select the “Start Over” button to learn about policies for other research outputs (i.e., model organisms, research tools).</p>
         <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
		links: `Resources:<br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/gds/overview'>GDS Policy Overview</a><br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/gds/expectations-by-ics'>GDS Data Sharing Expectations by NIH Institute and Center</a>`,
	},
	// a-10
	{
		id: "a-10",
		answer: `Based on your answers, the following policies apply to your research:<br><br>
         <i class="fas fa-check-circle me-2 text-success"></i> Genomic Data Sharing Policy<br>
         <i class="fas fa-check-circle me-2 text-success"></i> 2003 Data Sharing Policy
         `,
		note: `
         <p>The Genomic Data Sharing Policy applies to all NIH-funded research (e.g., grants, contracts, and intramural research) that generates <strong>large-scale human or non-human genomic data</strong>, regardless of the funding level, as well as the use of these data for subsequent research.</p>
         <p>The 2003 Data Sharing Policy applies to <strong>final research data</strong>, defined as recorded factual material commonly accepted in the scientific community as necessary to validate research findings. Final research data do not include laboratory notebooks, partial datasets, preliminary analyses, drafts of scientific papers, plans for future research, peer review reports, communications with colleagues, or physical objects, such as gels or laboratory specimens.</p>
         <p>Other NIH sharing policies may still apply. Select the “Start Over” button to learn about policies for other research outputs (i.e., model organisms, research tools).</p>
         <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
		links: `Resources:<br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/gds/overview'>GDS Policy Overview</a><br>
         <a href='/policy-topics/sharing-policies/gds/expectations-by-ics'>GDS Policy Expectations by NIH Institute and Center</a><br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/dms/policy-overview#2003-nih-data-sharing-policy'>2003 Data Sharing Policy</a>`,
	},
	// a-11
	{
		id: "a-11",
		answer: `Based on your answers, the following policies apply to your research:<br><br>
         <i class="fas fa-check-circle me-2 text-success"></i> Genomic Data Sharing Policy<br>
         <i class="fas fa-check-circle me-2 text-success"></i> Data Management & Sharing (DMS) Policy
         `,
		note: `
         <p>The Genomic Data Sharing Policy applies to all NIH-funded research (e.g., grants, contracts, and intramural research) that generates <strong>large-scale human or non-human genomic data</strong>, regardless of the funding level, as well as the use of these data for subsequent research.</p>
         <p>The DMS Policy, effective on January 25, 2023, applies to all research, funded or conducted in whole or in part by NIH, that results in the generation of <strong>scientific data. Scientific Data</strong> is defined as data commonly accepted in the scientific community as of sufficient quality to validate and replicate research findings, regardless of whether the data are used to support scholarly publications.<p>
         <p>Other NIH sharing policies may still apply. Select the “Start Over” button to learn about policies for other research outputs (i.e., model organisms, research tools).</p>
         <p>Note that Individual <a href="/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
		links: `Resources:<br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/gds/overview'>GDS Policy Overview</a><br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/gds/expectations-by-ics'>GDS Policy Expectations by NIH Institute and Center</a><br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/dms/policy-overview'>Data Management & Sharing Policy Overview</a>`,
	},
	// a-12
	{
		id: "a-12",
		answer: `<i class="fas fa-times-circle me-2 text-danger"></i>
         Based on your answers, the NIH Genomic Data Sharing Policy and 2003 Data Sharing Policy <strong>do not apply</strong> to your research.`,
		note: `
            <p>Other NIH sharing policies may still apply. Select the “Start Over” button to learn about policies for other research outputs (i.e., model organisms, research tools).</p>
            <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
	},
	// a-14
	{
		id: "a-14",
		answer: `<i class="fas fa-times-circle me-2 text-danger"></i>Based on your answers, the NIH Model Organism Sharing Policy <strong>does not apply</strong> to your research.`,
		note: `
            <p>Other NIH sharing policies may still apply. Select the “Start Over” button to learn about policies for other research outputs.</p>
            <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
	},
	// a-16
	{
		id: "a-16",
		answer: `<i class="fas fa-check-circle me-2 text-success"></i> Based on your answers, the <strong>Model Organism</strong> policy applies to your research.`,
		note: `
         <p>NIH's Model Organism Policy only applies to non-human model organisms and does not apply to human cells that are not commercially available. The policy also does not apply to bacteria, viruses, and other non-eukaryotic organisms.</p>
         <p>The NIH <strong>Research Tools policy</strong> may also apply to you. Select the “Start Over” button to learn more.</p>
         <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
		links: `Resources:<br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/other/model-organism'>Model Organism Policy</a><br>`,
	},
	// a-20
	{
		id: "a-20",
		answer: `<i class="fas fa-check-circle me-2 text-success"></i> Based on your answers, the <strong>Research Tools</strong> policy applies to your research.`,
		note: `
         <p>NIH's Research Tools Policy applies to unique research resources that can be used in the laboratory. Examples include cell lines, monoclonal antibodies, reagents, animal models, growth factors, combinatorial chemistry and DNA libraries, clones and cloning tools (such as PCR), methods, laboratory equipment and machines.<br></p>
         <p>Other NIH sharing policies may still apply. Select the “Start Over” button to learn about policies for other research outputs.</p>
         <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
		links: `Resources:<br>
         <a href='/policy-and-compliance/policy-topics/sharing-policies/other/research-tools'>Research Tools Policy</a><br>`,
	},
	// a-21
	{
		id: "a-21",
		answer: `<i class="fas fa-times-circle me-2 text-danger"></i> Based on your answers, the Research Tools policy <strong>does not apply</strong> to your research.`,
		note: `
            <p>Other NIH sharing policies may still apply. Select the “Start Over” button to learn about policies for other research outputs.</p>
            <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
		links: `Resources:<br>
            <a href='/policy-topics/sharing-policies/other/research-tools'>Research Tools Policy</a><br>`,
	},
	// a-22
	{
		id: "a-22",
		answer: `You have indicated that you are not or will not be generating data, model organisms, or research tools. Based on this answer, none of the following policies apply to your research:<br><br>
         <i class="fas fa-times-circle me-2 text-danger"></i> NIH 2003 Data Sharing Policy<br>
         <i class="fas fa-times-circle me-2 text-danger"></i> NIH Data Management & Sharing Policy<br>
         <i class="fas fa-times-circle me-2 text-danger"></i> NIH Genomic Data Sharing Policy<br>
         <i class="fas fa-times-circle me-2 text-danger"></i> NIH Model Organisms Policy<br>
         <i class="fas fa-times-circle me-2 text-danger"></i> NIH Research Tools Policy`,
		note: `
               <p>Note that Individual <a href="/policy-and-compliance/policy-topics/sharing-policies/other/ics-sharing-policies">NIH Institutes or Centers may have additional policies</a> or requirements. Always check with a program official and read your funding opportunity closely to be sure you are complying with all expectations.</p>`,
	},
];

export { questions, answers };